import { render, staticRenderFns } from "./CopyrightAssignmentTransferPopupDetails.vue?vue&type=template&id=2a21fa0a&scoped=true&"
import script from "./CopyrightAssignmentTransferPopupDetails.vue?vue&type=script&lang=js&"
export * from "./CopyrightAssignmentTransferPopupDetails.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightAssignmentTransferPopupDetails.vue?vue&type=style&index=0&id=2a21fa0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a21fa0a",
  null
  
)

export default component.exports